var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-container',{staticClass:"h-100 d-flex flex-column p-0",attrs:{"fluid":""}},[_c('b-row',{staticClass:"p-0 flex-grow-1 overflow-auto no-gutters"},[_c('Map',_vm._g({attrs:{"Variant":_vm.Variant}},_vm.$listeners))],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }